import { render, staticRenderFns } from "./ghac.vue?vue&type=template&id=7883e441&scoped=true&"
import script from "./ghac.vue?vue&type=script&lang=js&"
export * from "./ghac.vue?vue&type=script&lang=js&"
import style0 from "./ghac.vue?vue&type=style&index=0&id=7883e441&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7883e441",
  null
  
)

export default component.exports